// extracted by css-extract-rspack-plugin
export default {"totalAllocatedStatus":"totalAllocatedStatus-ZfP1wT text-base-light","exact":"exact-FfWrGF","over":"over-K9itSv","allocatedAmount":"allocatedAmount-ci_DE1"};